import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map, mergeMap, take} from 'rxjs/operators';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {ConfigModel} from '../services/config/config.model';
import {ErrorResponseModel} from '../models/errorResponse.model';
import {UserLogout} from '../../state/actions/appState.account.actions';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  @Select(AppState.config$) config$: Observable<ConfigModel>;

  constructor(private store: Store) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.config$.pipe(
      take(1),
      mergeMap((config) => {
        if (config && config.gateway && config.gateway.api) {
          request = request.clone({
            url: `${config.gateway.api}${request.url}`
          });
        }
        return next.handle(request).pipe(
          catchError((err: HttpErrorResponse) => {
            console.log(err);
            if (err.status === 401 && !(err.error as ErrorResponseModel).path.endsWith('currentUser')) {
              return this.store.dispatch(new UserLogout());
            } else {
              return throwError(err);
            }
          }),
        );
      })
    );
  }
}
